// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var MarginTypes;
(function (MarginTypes) {
    MarginTypes[MarginTypes["MARGIN_PFS"] = 0] = "MARGIN_PFS";
    MarginTypes[MarginTypes["MARGIN_FIXED"] = 2] = "MARGIN_FIXED";
    MarginTypes[MarginTypes["MARGIN_FULL"] = 4] = "MARGIN_FULL";
    MarginTypes[MarginTypes["MARGIN_PT_RISK_MODULE"] = 6] = "MARGIN_PT_RISK_MODULE";
    MarginTypes[MarginTypes["MARGIN_PRICE_LIMIT"] = 7] = "MARGIN_PRICE_LIMIT";
    MarginTypes[MarginTypes["MARGIN_STOCK"] = 12] = "MARGIN_STOCK";
    MarginTypes[MarginTypes["MARGIN_NSE_VAR"] = 13] = "MARGIN_NSE_VAR";
    MarginTypes[MarginTypes["MARGIN_PT_RISK_MODULE_EXPOSURE"] = 14] = "MARGIN_PT_RISK_MODULE_EXPOSURE";
    MarginTypes[MarginTypes["MARGIN_NONE"] = 16] = "MARGIN_NONE";
    MarginTypes[MarginTypes["MARGIN_CUSTOM_COEF_WITH_FIXED_VALUE"] = 17] = "MARGIN_CUSTOM_COEF_WITH_FIXED_VALUE";
    MarginTypes[MarginTypes["LONG_OPTIONS_FULLY_PAID_MARGIN"] = 18] = "LONG_OPTIONS_FULLY_PAID_MARGIN";
    MarginTypes[MarginTypes["TIERED_PRICE_BASED_CUSTOM_COEF"] = 19] = "TIERED_PRICE_BASED_CUSTOM_COEF";
    MarginTypes[MarginTypes["PRICE_BASED_MULTIPLE_COEF"] = 20] = "PRICE_BASED_MULTIPLE_COEF";
    MarginTypes[MarginTypes["MARGIN_CUSTOM_FIXED"] = 21] = "MARGIN_CUSTOM_FIXED";
    MarginTypes[MarginTypes["TIERED_PRICE_BASED_CUSTOM_COEF_WITH_RANGES"] = 22] = "TIERED_PRICE_BASED_CUSTOM_COEF_WITH_RANGES";
    MarginTypes[MarginTypes["FIXED_INCOME_PRE_PAID"] = 23] = "FIXED_INCOME_PRE_PAID";
    MarginTypes[MarginTypes["TIERED_BY_GROUP"] = 24] = "TIERED_BY_GROUP";
})(MarginTypes || (MarginTypes = {}));
